import React from 'react';
import { Link } from 'react-router-dom';
import { FaBath, FaBed, FaClock } from 'react-icons/fa'; 

const PropertyCard = ({ property }) => {
  

  return (
    <Link to="contact" smooth={true} duration={800} className="property-card-link">
      <div className="property-card" style={{ width: '300px', height: '400px', marginTop: '30px', backgroundColor: 'white' }}>
        <img src={property.img} alt={property.type} />
        <div className="property-info">
          <h3>{property.type}</h3>
          
          <p><FaBed /> Rooms: {property.rooms}</p>
          <p><FaBath /> Baths: {property.baths}</p>
          <p><FaClock /> Distance to Airport: {property.distance}</p>

        </div>
        <h4>Price: {property.price}</h4>
      </div>
    </Link>
  );
};

export default PropertyCard;
